class PriceSeter {
    constructor(price) {
        this.prices = price;

        this.$price = $('.woocommerce-Price-amount');
        this.$color = $('#pa_color');
        this.$picked = $('.js-color-picked');
        this.$size = $('#pa_size');
        this.$qty = $('.input-text.qty');

        $('.single_add_to_cart_button').attr('disabled', 'disabled');

        this.$price.html('--').css('visibility', 'visible');

        this.checkIfSelected();
        this.eventHandlers()
    }

    eventHandlers() {
        $('.js-set-color').on('click', (e) => {
            $('.js-set-color').removeClass('active');
            $(e.target).addClass('active');

            this.color = $(e.target).data('value');
            this.title = $(e.target).data('title');
            this.$color.val(this.color);

            this.color = this.$color.val();
            this.checkIfSelected();

            this.$picked.html(this.title);

            this.$color.trigger('change').trigger('select.fs');
        });

        this.$qty.on('input', () => {
            this.qty = this.$qty.val();
            this.checkIfSelected();
        });

        this.$size.on('change', () => {
            this.size = this.$size.val();
            this.checkIfSelected();
        });
    }

    checkIfSelected() {
        this.size = this.$size.val();
        this.color = this.$color.val();
        this.qty = this.$qty.val();

        if (this.size && this.color && this.qty > 0) {
            this.setPrice();
        }
    }

    setPrice() {
        let prices = $.map(this.prices[this.color], function (value, index) {
            return [{
                'price': value,
                'amount': index
            }];
        });

        $.each(prices, (index, value) => {
            if (parseInt(this.qty) >= parseInt(value.amount) || index == 0) {
                this.price = value.price;
            }
        });

        this.$price.html('€' + this.price);

        $('.single_add_to_cart_button').removeAttr('disabled');
    }
}

module.exports = PriceSeter;
